// @ts-nocheck
import React, {HTMLAttributes} from "react";
import {observer} from "mobx-react";
import clsx from "clsx";

type PaddingType = "normal" | "none"

export interface ContentProps {
  size?: 'large' | 'half'
  sectionName?: string | React.ReactNode,
  title?: string,
  onHeaderClick?: () => void,
  visible?: boolean,
  padding?: PaddingType
}

@observer
export default class Section extends React.Component<ContentProps & HTMLAttributes<HTMLDivElement>> {
  render() {
    const {size, visible, padding, onHeaderClick, sectionName, ...rest} = this.props;

    const className = "section-container" + (this.props.size ? " " + this.props.size + "-section" : "") + (this.props.visible === false ? " hidden" : "" + (this.props.padding ? " p-" + this.props.padding : "")) + (rest.className ? " " + rest.className : "");

    return <div {...this.props} className={clsx(className, 'lg:mx-10 lg:my-5 mb-6 lg:max-w-[95%]')}>
      {this.props.sectionName || this.props.title ?
        <div className={"section-header-container"}>{typeof this.props.sectionName === 'string' ?
          <h2>{this.props.sectionName || this.props.title}</h2> : <>{this.props.sectionName  || this.props.title}</>}</div> : <></>}
      <div className={"section-body"}>
        {this.props.children}
      </div>
    </div>
  }
}
